/**
 * Moduł umożliwiający opłacenie zaległych płatności subskrypcyjnych.
 * Wykorzystywany na stronie głównej KME oraz liście płatności miesięcznych.
 */
app.service('accountSubscriptionPayments', function (modal, loading, ajaxErrorHandler) {

	/**
	 * Obsługa przycisku "Opłać składkę"
	 * @param recurringPaymentId
	 * @param singlePaymentId
	 */
	function paySubscriptionFee(recurringPaymentId, singlePaymentId) {
		loading.start();

		makePaySubscriptionFeeRequest(recurringPaymentId, singlePaymentId)
			.done(response => {
				if (response.status === 'SUCCESS') {
					redirectToAccountPayment(response);
				} else {
					modal.alert(response.errorMessage);
				}
			})
			.fail(ajaxErrorHandler.createFailHandler('accountSubscriptionPayments.paySubscriptionFee'))
			.always(() => {
				loading.stop();
			});
	}

	function makePaySubscriptionFeeRequest(recurringPaymentId, singlePaymentId) {
		return $.ajax({
			method: 'POST',
			url: '/customer-subscription-payment-by-link.ltr',
			contentType: 'application/json',
			data: JSON.stringify({
				recurringPaymentId,
				singlePaymentId
			})
		});
	}

	/**
	 * Obsługa przycisku "Aktywuj ochronę sprzetu"
	 * Inicjuje proces utworzenia płatności cyklicznej w MOP.
	 * Przekierowuje na stronę płatności /konto-platnosc.bhtml dla zwróconego identyfikatora płatności
	 * @param orderNumber - numer zamówienia, którego dotyczy płatność
	 */
	function initRecurringPayment(orderNumber) {
		loading.start();

		makeInitRecurringPaymentRequest(orderNumber)
			.then(response => {
				if (response.status === 'FAIL') {
					modal.alert(response.messages);
				} else {
					redirectToAccountPayment(response);
				}
			})
			.fail(ajaxErrorHandler.createFailHandler('accountSubscriptionPayments.initRecurringPayment'))
			.always(() => {
				loading.stop();
			});
	}

	function makeInitRecurringPaymentRequest(orderNumber) {

		return $.ajax({
			method: 'POST',
			url: '/subscription-transaction-payment.ltr',
			data: {
				orderNumber
			}
		});
	}

	function redirectToAccountPayment(response) {
		loading.redirect(response.transactionPaymentUrl);
	}

	return {
		initRecurringPayment,
		paySubscriptionFee
	};
});